import { render, staticRenderFns } from "./platform-menus.vue?vue&type=template&id=1b8b9eb0"
import script from "./platform-menus.vue?vue&type=script&lang=js"
export * from "./platform-menus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports